import React, { memo } from "react";
import Avatar from "@material-ui/core/Avatar";
import useStyles from "./styles";
import clsx from "clsx";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";

const UserAvatar = (props) => {
  const classes = useStyles();

  return <Avatar className={clsx(classes.avatar)} src={<PermIdentityIcon />} />;
};

export default memo(UserAvatar);
